import { BoardPage } from './pages/BoardPage.js';
import { JoinPage } from './pages/JoinPage.js';
import { LandingPage } from './pages/LandingPage.js';
import { LecturesPage } from './pages/LecturesPage.js';
import { TeacherHomePage } from './pages/TeacherHomePage.js';
import { TeacherSignInPage } from './pages/TeacherSignInPage.js';
import { useRoute } from './router.js';

/** Chooses the screen for the current address. Unknown paths land on the landing screen. */
export function App() {
  const route = useRoute();

  switch (route) {
    case '/teacher':
      return <TeacherSignInPage />;
    case '/home':
      return <TeacherHomePage />;
    case '/board':
      return <BoardPage />;
    case '/lectures':
      return <LecturesPage />;
    case '/join':
      return <JoinPage />;
    case '/':
    default:
      return <LandingPage />;
  }
}
